export default "__VITE_ASSET__C7yE1KYw__"